import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Sparkles, Trash2 } from "lucide-react";

export default function DemoSeeder({ onDone }) {
  const [busy, setBusy] = useState("");

  const run = async (kind) => {
    setBusy(kind);
    try {
      const { data } = await api.post(`/admin/demo/${kind}`);
      toast.success(kind === "seed"
        ? `Demo ready: ${data.helpers} helpers, ${data.seekers} seekers, ${data.requests} visits (password ${data.password})`
        : `Demo data removed (${data.users_removed} users, ${data.requests_removed} visits)`);
      onDone?.();
    } catch { toast.error("Couldn't update demo data. Please try again."); }
    finally { setBusy(""); }
  };

  return (
    <div data-testid="demo-seeder" className="bg-[#FFF4EC] border border-[#F3C9B1] rounded-2xl p-5 mb-8 flex flex-wrap items-center justify-between gap-4">
      <div>
        <p className="font-semibold text-slate-900">Demo data</p>
        <p className="text-slate-600 text-sm">Fill Kindred with sample neighbours and three weeks of visits for a live demo. Demo accounts end in @kindred.demo.</p>
      </div>
      <div className="flex gap-3">
        <button data-testid="demo-seed-btn" onClick={() => run("seed")} disabled={!!busy}
          className="bg-[#D96B43] hover:bg-[#C25832] disabled:opacity-60 text-white font-semibold px-5 min-h-[48px] rounded-xl flex items-center gap-2 transition-colors">
          <Sparkles className="w-5 h-5" /> {busy === "seed" ? "Filling…" : "Fill with demo data"}
        </button>
        <button data-testid="demo-reset-btn" onClick={() => run("reset")} disabled={!!busy}
          className="border-2 border-[#E2D9CE] hover:border-red-400 disabled:opacity-60 bg-white text-slate-700 font-semibold px-5 min-h-[48px] rounded-xl flex items-center gap-2 transition-colors">
          <Trash2 className="w-5 h-5" /> {busy === "reset" ? "Clearing…" : "Clear demo data"}
        </button>
      </div>
    </div>
  );
}
